<div>
  <form>
    <div>
      <input type="radio" [(ngModel)]="searchFilter" name="searchFilterOption" value="Id" (change)="change('Id')"> StudentId
      <input type="radio" [(ngModel)]="searchFilter" name="searchFilterOption" value="Phone" (change)="change('Phone')"> PhoneNumber
  </div>
  <input *ngIf="searchFilter == 'Id'" type="number" min="1" class="input input_button" name="syStudentId" [(ngModel)]="search.syStudentId" placeholder="Search by StudentId" (keyup.enter)="getStudents()">
  <input *ngIf="searchFilter == 'Phone'" type="number" class="input input_button" name="phoneNumber" [(ngModel)]="search.phoneNumber" placeholder="Search by PhoneNumber"(keyup.enter)="getStudents()">
  </form>
  <button type="submit" class="btn-large red" (click)="getStudents()">Search</button>
  <app-student-list *ngIf="students" [students]="students"></app-student-list>
</div>
